import { useQueries } from "@tanstack/react-query";
import React from "react";
import { EPD } from "./EPD";
import { LoadingState } from "@shared/common/components/State/LoadingState";
import { ErrorState } from "@shared/common/components/State/ErrorState";
import { EmptyState } from "@shared/common/components/State/EmptyState";
import { usePrepareStore } from "@shared/common/hooks/usePrepareStore";
import { useKnopClient } from "@opstel/contexts/knopClient/useKnopClient";
import { useCurrentInstanceId } from "@shared/common/contexts/instanceMetadata/useInstanceId";
import { instances } from "@opstel/query/queryKeys/instanceKeys";
import { useKnopIsLoading } from "@shared/common/hooks/useKnopIsLoading";

export function EPDWrapper(): React.JSX.Element {
  const isLoading = useKnopIsLoading((state) => state.isLoading);
  const { knopClient } = useKnopClient();
  const { instanceId } = useCurrentInstanceId();
  const queries = useQueries({
    queries: [
      {
        queryKey: instances.current(instanceId).scenario,
        queryFn: () => knopClient.getScenario(instanceId),
      },
      {
        queryKey: instances.current(instanceId).epdData,
        queryFn: () => knopClient.getEpdData(instanceId),
      },
    ],
  });

  const [{ data: scenario }, { data: epdData }] = queries;
  usePrepareStore(scenario, queries);

  if (isLoading || queries.some((q) => q.isLoading)) return <LoadingState fullPage={false} />;
  if (queries.some((q) => q.isError)) {
    queries.filter((q) => q.isError).forEach((q) => console.log(q.error));
    return <ErrorState />;
  }
  if (!scenario || !epdData) return <EmptyState />;

  return (
    <EPD
      key={instanceId}
      actions={epdData.actions}
      location={epdData.location}
      shuntingUnits={epdData.shuntingUnitsById}
    />
  );
}
